import { Component, Input } from '@angular/core';

@Component({
  selector: 'un-social-link',
  templateUrl: 'social-link.component.html',
  styleUrls: ['social-link.component.scss'],
  standalone: false,
})
export class SocialLinkComponent {
  @Input() public url?: string;
  @Input() public icon?: string;
}
